import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
import Progressbar from "../../Components/Progressbar";
import { useNavigate } from "react-router-dom";
/** Components Import */
import MM10070View from "../../Views/Manufacture/MM10070";
import MM10071View from "../../Views/Manufacture/MM10071";
import Snackbar from "../../Components/Snackbar";

function MM10070(props) {
  const navigate = useNavigate();
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [lanData, setLanData] = React.useState([]);
  const [bomDataList, setBomDataList] = React.useState([
    {
      value: "",
      name: "",
    },
  ]);
  const [progress, setProgressbar] = React.useState(false);

  const [procDataList, setProcDataList] = React.useState([]);
  const [bomData, setBomData] = React.useState("");
  const [procData, setProcData] = React.useState("");

  const [modalToggle, setModalToggle] = React.useState(false);
  const [tabToggle, setTabToggle] = React.useState(false);
  const [inputs, setInputs] = React.useState({
    //자재투입정보
    bomSoQty: 0,
    bomOrderQty: 0,
    bomWorkQty: 0,
    bomItemList: [
      {
        value: "",
        name: "",
      },
    ],
    bomItemNm: "", //자재품명
    SoQty: 0, //주문수량
    OrderQty: 0, //지시수량
    WorkQty: 0, //생산수량

    //생산정보
    workStartDt: "", //시작일
    workEndDt: "", //종료일

    //작업지시정보
    custNm: "", //거래처
    itemNm: "", //제품품명
    itemType: "", //품목타입
    soNo: "",
    woNo: "",
    barcodeValue: "",
    procNm: "",
    title: "공정현황(PDA)",
  });
  let bomItemLists = [];

  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    SearchLogic();
  }, []);

  React.useEffect(() => {}, []);
  const SearchLogic = async (_woNo) => {
    let getLanData = [];

    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  //작업지시번호스캔
  const WoNoSearch = async (_woNo) => {
    // Dialog.ProgressBar(true);
    setProgressbar(true);

    let userInfo = null;
    let getLanData = [];
    let getRowData = [
      {
        value: "",
        name: "",
      },
    ];
    let getProcData = [
      {
        value: "",
        name: "",
      },
    ];
    let a = [];
    let b = [];
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });

      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Manufacture.MM10070.GetWork,
        {
          woNo:
            _woNo == "" || _woNo == undefined || _woNo == null
              ? inputs.barcodeValue
              : _woNo,
        }
      ).then((result) => {
        let data = result.data;
        let data1 =
          !data[0] || data[0].bomItemCd == null
            ? ""
            : data[0].bomItemCd.split(",");
        let data2 =
          !data[0] || data[0].bomItemNm == null
            ? ""
            : data[0].bomItemNm.split(",");
        if (data == "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
          setInputs({
            ...inputs,
            barcodeValue: "",
            bomItemNm: "",
            custNm: "",
            itemNm: "",
            itemType: "",
            SoQty: 0,
            OrderQty: 0,
            WorkQty: 0,
            bomOrderQty: 0,
            processNm: "",
            wkStDt: "",
            wkEdDt: "",
            bomItemList: [],
          });
        } else {
          setInputs({
            ...inputs,
            woNo: data[0].woNo,
            SoQty: data[0].soQty,
            OrderQty: data[0].orderQty,
            WorkQty: data[0].workQty,
            custNm: data[0].custNm,
            itemNm: data[0].itemNm,
            itemType: data[0].itemType,
            barcodeValue: "",
            soNo: data[0].soNo,
            itemCd: data[0].itemCd,
            processNm: data[data.length - 1].processNm,
            // orSeq: data.CurrentWorks.OrSeq,
          });
          setModalToggle(true);
          for (let i = 0; i < data1.length; i++) {
            getRowData.push({
              value: data1[i],
              name: data2[i],
            });
          }
          for (let i = 0; i < data.length; i++) {
            getProcData.push({
              value: data[i].machineCd,
              name: data[i].machineNm,
            });
          }
          setProcDataList(getProcData);
          setBomDataList(getRowData);
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      setProgressbar(false);

      // Dialog.ProgressBar(false);
    }
  };

  const SearchBomData = async (_bomItemCd, _soNo, _woNo, _itemCd) => {
    // Dialog.ProgressBar(true);
    setProgressbar(true);

    try {
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Manufacture.MM10070.GetBomWork,
        {
          bomItemCd: _bomItemCd,
          soNo: _soNo,
          woNo: _woNo,
          itemCd: _itemCd,
        }
      ).then((result) => {
        let data = result.data;
        if (data.length > 0) {
          setInputs({
            ...inputs,
            bomSoQty: data[0].bomSoQty,
            bomOrderQty: data[0].bomOrderQty,
            bomWorkQty: data[0].bomWorkQty,
          });
        } else {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      // Dialog.ProgressBar(false);
      setProgressbar(false);
    }
  };
  const ProcMove = async () => {
    navigate("/ManufactureManagement/MM10060");
  };
  const SearchProcData = async (_procCd, _woNo) => {
    // Dialog.ProgressBar(true);
    setProgressbar(true);

    try {
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Manufacture.MM10070.GetProcWork,
        {
          processCd: _procCd,
          woNo: _woNo,
        }
      ).then((result) => {
        let data = result.data;
        if (data.length > 0) {
          setInputs({
            ...inputs,
            wkStDt: data[0].wkStDt ? data[0].wkStDt.replace("T", " ") : "",
            wkEdDt: data[0].wkEdDt ? data[0].wkEdDt.replace("T", " ") : "",
          });
        } else {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      // Dialog.ProgressBar(false);
      setProgressbar(false);
    }
  };

  return (
    <div className="card">
      {!tabToggle ? (
        <MM10070View
          inputs={inputs}
          setInputs={setInputs}
          WoNoSearch={WoNoSearch}
          bomItemLists={bomItemLists}
          tabToggle={tabToggle}
          setTabToggle={setTabToggle}
          lanData={lanData}
          modalToggle={modalToggle}
          setModalToggle={setModalToggle}
        />
      ) : (
        <MM10071View
          inputs={inputs}
          setInputs={setInputs}
          WoNoSearch={WoNoSearch}
          ProcMove={ProcMove}
          bomItemLists={bomItemLists}
          tabToggle={tabToggle}
          setTabToggle={setTabToggle}
          lanData={lanData}
          SearchBomData={SearchBomData}
          setBomData={setBomData}
          bomData={bomData}
          setBomDataList={setBomDataList}
          bomDataList={bomDataList}
          modalToggle={modalToggle}
          setModalToggle={setModalToggle}
          procDataList={procDataList}
          setProcDataList={setProcDataList}
          procData={procData}
          setProcData={setProcData}
          SearchProcData={SearchProcData}
        />
      )}

      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
      <Progressbar value={progress} />
    </div>
  );
}

export default MM10070;
